import {
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import * as utils from 'utils/utils';

import { BaseModalComponent } from 'shared/modal/_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'publish-modal',
  templateUrl: 'publish-modal.component.html',
  styleUrls: ['publish-modal.component.scss'],
})
export class PublishModalComponent extends BaseModalComponent {

  @Input() selectedItems: number;

  @Output() confirm: EventEmitter<any> = new EventEmitter();

  onCancelClick() {
    this.hide();
  }

  onConfirmClick() {
    this.confirm.emit();
    this.hide();
  }
}
